import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class SpeciesLabel extends AbstractProvidedClass {
    constructor(provider, { id, keys }) {
        super(provider);

        this.id = id;
        this.keys = keys;
    }

    hasLabels() {
        return this.keys.length > 0;
    }

    setParent(parent) {
        this.parent = parent;
    }

    getValue(index = 0) {
        return this.keys.length >= index + 1
            ? this.getSpeciesValue(this.keys[index])
            : null;
    }

    getValues() {
        return this.keys.map(key => this.getSpeciesValue(key));
    }

    getSpeciesValue(key) {
        return this.speciesCollection.get(this.id)[key];
    }

    showKey(key) {
        this.keys.push(key);
    }

    hideKey(key) {
        this.keys = this.keys.filter(k => k != key);
    }

    clone() {
        return new SpeciesLabel(this.provider, {
            id: this.id,
            keys: Array.from(this.keys),
        });
    }

    export() {
        return {
            type: 'species',
            id: this.id,
            keys: this.keys,
        };
    }

    get index() {
        return this.parent.getIndexOf(this);
    }
}
